/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
export const apiMap = {
    getOTP: {
        "api":"cn-rbb-lending-otp-sapi-prod-proxy/v1/otp",
        "json":"opt.json"
    },
    logon: {
        //"api":"rbbob-pa-logon-prod-proxy/v0/logon",
        "api":"cn-rbb-lending-logon-papi-prod-proxy/v1/logon",
        "json":"logon.json"
    },
    previewSubmit: {
        //"api":"rbbob-pa-submit-prod-proxy/v0/preview",
        "api":"cn-rbb-lending-submit-papi-prod-proxy/v1/preview",
        "json":"preview.json"
    },

    updateApplication: {
        //"api":"rbbob-sa-application-prod-proxy/v0/application",
        "api":"cn-rbb-lending-application-sapi-prod-proxy/v1/application",
        "json":"updateApplication.json"
    },

    submitApp: {
        //"api":"rbbob-pa-submit-prod-proxy/v0/submit",
        "api":"cn-rbb-lending-submit-papi-prod-proxy/v1/submit",
        "json":"submitApp.json"
    },
    unfrozen: {
        //"api":"rbbob-pa-submit-prod-proxy/v0/unfrozen",
        "api":"cn-rbb-lending-submit-papi-prod-proxy/v1/unfrozen",
        "json":"unfrozen.json"
    },
    getStaticData: (num) => {
        return {
            //"api": "rbbob-sa-staticdata-prod-proxy/v0/staticdata/" + num,
            "api": "cn-rbb-lending-staticdata-sapi-prod-proxy/v1/staticdata/" + num,
            "json":"staticdatas.json"
        }
    },
    retrvApp: (applicationId) => {
        return {
            //"api": `rbbob-sa-application-prod-proxy/v0/application/${applicationId}`,
            "api": `cn-rbb-lending-application-sapi-prod-proxy/v1/application/${applicationId}`,
            "json":"retrvApp.json"
        }
    },
    getBusinessInfo: (applicationId) => {
        return {
            //"api": `rbbob-sa-business-prod-proxy/v0/busandqs/${applicationId}`,
            "api": `cn-rbb-lending-business-sapi-prod-proxy/v1/busandqs/${applicationId}`,
            "json":"business.json"
        }
    },
    getSectionTemplate: (version,countryCode) => {
        return {
            //"api": `rbbob-sa-section-prod-proxy/v0/section/${version}/${countryCode}`,
            "api": `cn-rbb-lending-section-sapi-prod-proxy/v1/section/${version}/${countryCode}`,
            "json":"sectionTemplate.json"
        }
    },
    updateBusiness: {
        //"api":'rbbob-sa-business-prod-proxy/v0/busandqs',
        "api":'cn-rbb-lending-business-sapi-prod-proxy/v1/busandqs',
        "json":"updateBusiness.json"
    },
    UploadFile:{
        "api": "/v1/documents",
        "json":"documents.json"
    },
    retrieveUserMobile: (appId) => {
        return {
            //"api": `rbbob-sa-user-prod-proxy/v0/usermobile/${appId}`,
            "api": `cn-rbb-lending-user-sapi-prod-proxy/v1/usermobile/${appId}`,
            "json":"usermobile.json"
        }
    },
    getQianhai: {
        //"api":"rbbob-sa-qianhai-prod-proxy/v0/qianhai",
        "api":"cn-rbb-lending-qianhai-sapi-prod-proxy/v1/qianhai",
        "json":"logon.json"
    },
    getStatusFile: (documentId) => {
        return {
            "api": "/v1/documentStatus?ids=" + documentId,
            "json":"logon.json"
        }
    },
    getDownloadKey: (iccmFileNetId) => {
        return {
            //"api": "rbbob-sa-fileupload-prod-proxy/v0/iccmfile/getDownloadKey/" + iccmFileNetId,
            //"api": "cn-rbb-lending-fileupload-sapi-prod-proxy/v1/downloadKey/" + iccmFileNetId,
            "api": "cn-rbb-lending-downloadkey-sapi-prod-proxy/v1/downloadkey/" + iccmFileNetId,
            "json":"downloadKey.json"
        }
    },
    getDownloadFile: (key) => {
        return {
            //"api": "rbbob-sa-download-prod-proxy/v0/iccmfile/" + key,
            "api": "cn-rbb-lending-download-sapi-prod-proxy/v1/file/" + key,
            "json":"downloadFile.json"
        }
    },
    getImageCode: {
        "api":"cn-rbb-lending-otp-sapi-prod-proxy/v1/image-code",
        "json":"getImageCode.json"
    },
    //i18n url
    previewQuestion: "/api/locale/preview",
    accountI18n: "/api/locale/accountQuestion",
    basicInfo: "/api/locale/basicInfo",
    businessInfo: "/api/locale/businessInformation",
    help: "/api/locale/help",
	fileUploadI18n: "/api/locale/fileUpload",
	aoFormI18n:"/api/locale/aoFormHome",
	confirmPQi18n: "/api/locale/confirmPQ",
	applicantInformationI18n: "/api/locale/applicantInformation",
    companyRegistrationI18n: "/api/locale/companyRegistration",
    accountOpeningStepsI18n: "/api/locale/accountOpeningSteps",
    aoFormReviewI18n: "/api/locale/aoFormReview",
    systemErrorMessageI18n: "/api/locale/systemErrorMessage",
    appI18n: "/api/locale/app"
}
const muleGWCNUrl = "https://wpb-api.hsbc.com.cn/";
const muleGWHKUrl = "https://rbwm-api.hsbc.com.hk/";
export const settings = {
    default: {
        hostname: '',
        method: 'GET'
    },
    hostnameOTP: muleGWCNUrl,
    hostnameLogon: muleGWCNUrl,
    hostnameSubmit: muleGWCNUrl,
    hostnameSection: muleGWCNUrl,
    hostnameStaticData: muleGWCNUrl,
    hostnameApplication: muleGWCNUrl,
    hostBusiness: muleGWCNUrl,
    hostnameUploadFile: "/gdu-document-upload--zz-prod-proxy",
    //hostnameCallBack: "https://ms-rbb-sa-fileupload-v0-sct.cf.wgdc-drn-01.cloud.uk.hsbc/api/rbbob/callback",//配置文件
    hostnameRetrieveUserMobile: muleGWCNUrl,//查看电话
    hostnameQianhai: muleGWCNUrl,
    hostnameStatusUploadFile: muleGWHKUrl + "gdu-document-upload-status--zz-prod-proxy",
    hostnameDownloadKey: muleGWCNUrl, // get download key
    hostnameDownloadFlie: muleGWCNUrl, // download file
    hostnameImageCode: muleGWCNUrl,
    get: 'GET',
    post: 'POST',
    put: 'PUT',
    //upload
    client_id : "8c0fef628dd94e30a0c7bcd7b1fd34e5",
    client_secret : "461044D526404E9C97968a73f3b32Eb7",
    //get upload file status
    clientHeaders: {
         client_secret: '461044D526404E9C97968a73f3b32Eb7',
         client_id2: '8c0fef628dd94e30a0c7bcd7b1fd34e5',
         client_secret2: '461044D526404E9C97968a73f3b32Eb7',
         client_id: '8c0fef628dd94e30a0c7bcd7b1fd34e5'
     },
    //otp
    otpClientHeaders: {
        client_id : "23272abfc0bf426fbd532b428a65c33b",
        client_secret : "AaCDd5410C504624A241c20b657cD324"
    }
}



// WEBPACK FOOTER //
// ./src/config/constants.prod.js